import {} from './service'

const state = {
}

const mutations = {
  // setState (state, payload) {
  //   Object.assign(state, payload)
  // },
}

const actions = {
  async getList ({ state, commit, dispatch }) {
    const params = getParams(state)

    const lastDeptId = params.deptId.length
    params.deptId = lastDeptId ? params.deptId[lastDeptId - 1] : ''
    console.log(params)

    const res = await getList(params)

    if (res.code === 'success') {
      const { list, total, pageIndex } = res.data
      const { pageSize } = state.pagination

      const count = Math.ceil(total / pageSize)

      const index = count > pageIndex ? pageIndex : count

      commit('setState', {
        list: list.map((val, i) => {
          return {
            ...val,
            index: i + 1 + (index - 1) * pageSize * 1,
          }
        }),
        pagination: {
          ...state.pagination,
          pageCount: count,
          total,
          pageIndex: index,
        },
      })

      if (count !== 0 && count < pageIndex) {
        return dispatch('getList')
      }
    }

    return res
  },
}

export const homePage = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default homePage
